<script lang="ts">
  import { setFocus, getBorderColors } from "../../helpers/helperMethods";
  interface Props {
    value: string | undefined;
    error: boolean | undefined;
    id?: any;
    name?: any;
    max?: any;
    autoFocus?: boolean;
    autoFocusDelay?: boolean;
    disabled?: boolean;
    class?: string;
    required?: boolean;
    hasPressedContinue?: boolean;
  }

  let {
    value = $bindable(),
    error,
    id = undefined,
    name = undefined,
    max = undefined,
    autoFocus = false,
    autoFocusDelay = true,
    disabled = false,
    class: className,
    required = false,
    hasPressedContinue = false,
  }: Props = $props();

  const init = (el: HTMLInputElement) => {
    if (autoFocus) {
      setFocus(el, autoFocusDelay);
    }
  };
</script>

<input
  type="text"
  bind:value
  use:init
  maxlength={max == undefined ? "" : max}
  size={max == undefined ? "" : max}
  {disabled}
  {id}
  {name}
  aria-invalid={error}
  class="text-M h-10 p-2 rounded-md relative appearance-none {disabled
    ? 'bg-Neutral200 cursor-not-allowed text-Neutral700'
    : ''} {className} {getBorderColors(
    error ? true : false,
    value == undefined && !hasPressedContinue,
    disabled
  )}"
  {required}
/>
